import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@angular/material/menu';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@niceltd/sol/button';
import { ButtonModule } from '@niceltd/sol/button';
import * as i4$1 from '@niceltd/sol/icon';
import { IconModule } from '@niceltd/sol/icon';
import * as i4 from '@niceltd/sol/svg-sprite-icon';
import { SvgSpriteIconModule } from '@niceltd/sol/svg-sprite-icon';
function MenuItemComponent_span_2_span_1_sol_svg_sprite_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sol-svg-sprite-icon", 13);
  }
  if (rf & 2) {
    const child_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", child_r2.svgIconName)("spritePath", ctx_r5.spriteIconPath)("wrapperClass", "sol-menu-icon");
  }
}
function MenuItemComponent_span_2_span_1_hr_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 14);
  }
}
function MenuItemComponent_span_2_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "button", 4)(2, "div", 5)(3, "span", 6);
    i0.ɵɵtemplate(4, MenuItemComponent_span_2_span_1_sol_svg_sprite_icon_4_Template, 1, 3, "sol-svg-sprite-icon", 7);
    i0.ɵɵelementStart(5, "span", 8);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "span", 9);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(9, MenuItemComponent_span_2_span_1_hr_9_Template, 1, 0, "hr", 10);
    i0.ɵɵelement(10, "sol-menu-item", 11, 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const _r7 = i0.ɵɵreference(11);
    const child_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", child_r2.tooltipText);
    i0.ɵɵproperty("matMenuTriggerFor", _r7.childMenu)("disabled", child_r2.disabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", child_r2.svgIconName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(child_r2.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(child_r2.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r2.showDivider);
    i0.ɵɵadvance();
    i0.ɵɵproperty("items", child_r2.children)("variant", ctx_r3.variant);
  }
}
function MenuItemComponent_span_2_span_2_button_1_sol_svg_sprite_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sol-svg-sprite-icon", 13);
  }
  if (rf & 2) {
    const child_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", child_r2.svgIconName)("spritePath", ctx_r13.spriteIconPath)("wrapperClass", "sol-menu-icon");
  }
}
function MenuItemComponent_span_2_span_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function MenuItemComponent_span_2_span_2_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r17);
      const child_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.handleMenuItemClick(child_r2));
    });
    i0.ɵɵelementStart(1, "div", 5)(2, "span", 6);
    i0.ɵɵtemplate(3, MenuItemComponent_span_2_span_2_button_1_sol_svg_sprite_icon_3_Template, 1, 3, "sol-svg-sprite-icon", 7);
    i0.ɵɵelementStart(4, "span", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "span", 18);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const child_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate("title", child_r2.tooltipText);
    i0.ɵɵproperty("disabled", child_r2.disabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", child_r2.svgIconName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(child_r2.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(child_r2.description);
  }
}
function MenuItemComponent_span_2_span_2_div_2_ng_template_1_sol_svg_sprite_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sol-svg-sprite-icon", 13);
  }
  if (rf & 2) {
    const child_r2 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", child_r2.svgIconName)("spritePath", ctx_r21.spriteIconPath)("wrapperClass", "sol-menu-icon");
  }
}
function MenuItemComponent_span_2_span_2_div_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MenuItemComponent_span_2_span_2_div_2_ng_template_1_sol_svg_sprite_icon_0_Template, 1, 3, "sol-svg-sprite-icon", 7);
  }
  if (rf & 2) {
    const child_r2 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("ngIf", child_r2.svgIconName);
  }
}
function MenuItemComponent_span_2_span_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, MenuItemComponent_span_2_span_2_div_2_ng_template_1_Template, 1, 1, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(3, "sol-button", 21);
    i0.ɵɵlistener("click", function MenuItemComponent_span_2_span_2_div_2_Template_sol_button_click_3_listener() {
      i0.ɵɵrestoreView(_r26);
      const child_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.handleMenuItemClick(child_r2));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const _r20 = i0.ɵɵreference(2);
    const child_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate("title", child_r2.tooltipText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconPositionedFront", _r20);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(child_r2.label);
  }
}
function MenuItemComponent_span_2_span_2_hr_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 14);
  }
}
function MenuItemComponent_span_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, MenuItemComponent_span_2_span_2_button_1_Template, 8, 5, "button", 15)(2, MenuItemComponent_span_2_span_2_div_2_Template, 5, 3, "div", 16)(3, MenuItemComponent_span_2_span_2_hr_3_Template, 1, 0, "hr", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r2.type !== "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r2.type === "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r2.showDivider);
  }
}
function MenuItemComponent_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, MenuItemComponent_span_2_span_1_Template, 12, 9, "span", 3)(2, MenuItemComponent_span_2_span_2_Template, 4, 3, "span", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r2.children && child_r2.children.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !child_r2.children || child_r2.children.length === 0);
  }
}
function FloatingMenuComponent_span_3_span_1_sol_svg_sprite_icon_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sol-svg-sprite-icon", 14);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", item_r2.svgIconName)("spritePath", ctx_r6.spriteIconPath)("wrapperClass", "sol-menu-icon");
  }
}
function FloatingMenuComponent_span_3_span_1_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r2.description);
  }
}
function FloatingMenuComponent_span_3_span_1_hr_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 16);
  }
}
function FloatingMenuComponent_span_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "button", 4, 5)(3, "div", 6)(4, "span", 7);
    i0.ɵɵtemplate(5, FloatingMenuComponent_span_3_span_1_sol_svg_sprite_icon_5_Template, 1, 3, "sol-svg-sprite-icon", 8);
    i0.ɵɵelementStart(6, "span", 9);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, FloatingMenuComponent_span_3_span_1_span_8_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, FloatingMenuComponent_span_3_span_1_hr_9_Template, 1, 0, "hr", 11);
    i0.ɵɵelement(10, "sol-menu-item", 12, 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const _r9 = i0.ɵɵreference(11);
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", item_r2.tooltipText);
    i0.ɵɵproperty("matMenuTriggerFor", _r9.childMenu)("disabled", item_r2.disabled);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", item_r2.svgIconName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r2.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.showDivider);
    i0.ɵɵadvance();
    i0.ɵɵproperty("items", item_r2.children)("variant", ctx_r3.variant)("spriteIconPath", ctx_r3.spriteIconPath);
  }
}
function FloatingMenuComponent_span_3_span_2_button_1_sol_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sol-icon", 23);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("icon", item_r2.icon);
  }
}
function FloatingMenuComponent_span_3_span_2_button_1_sol_svg_sprite_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sol-svg-sprite-icon", 14);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", item_r2.svgIconName)("spritePath", ctx_r17.spriteIconPath)("wrapperClass", "sol-menu-icon");
  }
}
function FloatingMenuComponent_span_3_span_2_button_1_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r2.description);
  }
}
function FloatingMenuComponent_span_3_span_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function FloatingMenuComponent_span_3_span_2_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r24);
      const item_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.handleMenuItemClick(item_r2));
    });
    i0.ɵɵelementStart(1, "div", 6)(2, "span", 7);
    i0.ɵɵtemplate(3, FloatingMenuComponent_span_3_span_2_button_1_sol_icon_3_Template, 1, 1, "sol-icon", 21)(4, FloatingMenuComponent_span_3_span_2_button_1_sol_svg_sprite_icon_4_Template, 1, 3, "sol-svg-sprite-icon", 8);
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, FloatingMenuComponent_span_3_span_2_button_1_span_7_Template, 2, 1, "span", 22);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate("title", item_r2.tooltipText);
    i0.ɵɵproperty("disabled", item_r2.disabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", item_r2.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.svgIconName && !item_r2.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r2.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.description);
  }
}
function FloatingMenuComponent_span_3_span_2_div_2_ng_template_1_sol_svg_sprite_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "sol-svg-sprite-icon", 14);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r28 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", item_r2.svgIconName)("spritePath", ctx_r28.spriteIconPath)("wrapperClass", "sol-menu-icon");
  }
}
function FloatingMenuComponent_span_3_span_2_div_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FloatingMenuComponent_span_3_span_2_div_2_ng_template_1_sol_svg_sprite_icon_0_Template, 1, 3, "sol-svg-sprite-icon", 8);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("ngIf", item_r2.svgIconName);
  }
}
function FloatingMenuComponent_span_3_span_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, FloatingMenuComponent_span_3_span_2_div_2_ng_template_1_Template, 1, 1, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(3, "sol-button", 27);
    i0.ɵɵlistener("click", function FloatingMenuComponent_span_3_span_2_div_2_Template_sol_button_click_3_listener() {
      i0.ɵɵrestoreView(_r33);
      const item_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r31 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r31.handleMenuItemClick(item_r2));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const _r27 = i0.ɵɵreference(2);
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate("title", item_r2.tooltipText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconPositionedFront", _r27);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r2.label);
  }
}
function FloatingMenuComponent_span_3_span_2_hr_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 16);
  }
}
function FloatingMenuComponent_span_3_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵlistener("keydown.tab", function FloatingMenuComponent_span_3_span_2_Template_span_keydown_tab_0_listener($event) {
      return $event.stopPropagation();
    });
    i0.ɵɵtemplate(1, FloatingMenuComponent_span_3_span_2_button_1_Template, 8, 6, "button", 18)(2, FloatingMenuComponent_span_3_span_2_div_2_Template, 5, 3, "div", 19)(3, FloatingMenuComponent_span_3_span_2_hr_3_Template, 1, 0, "hr", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.type !== "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.type === "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.showDivider);
  }
}
function FloatingMenuComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, FloatingMenuComponent_span_3_span_1_Template, 12, 10, "span", 2)(2, FloatingMenuComponent_span_3_span_2_Template, 4, 3, "span", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.children && item_r2.children.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r2.children || item_r2.children.length === 0);
  }
}
class MenuItemComponent {
  constructor() {
    this.spriteIconPath = '';
  }
  get menuClassname() {
    return `sol-floating-menu ${this.variant}`;
  }
  handleMenuItemClick(item) {
    if (item.callbackFn) {
      item.callbackFn(item);
    }
  }
  static {
    this.ɵfac = function MenuItemComponent_Factory(t) {
      return new (t || MenuItemComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MenuItemComponent,
      selectors: [["sol-menu-item"]],
      viewQuery: function MenuItemComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatMenu, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childMenu = _t.first);
        }
      },
      inputs: {
        items: "items",
        variant: "variant",
        spriteIconPath: "spriteIconPath"
      },
      exportAs: ["floatingMenuItem"],
      decls: 3,
      vars: 4,
      consts: [[3, "overlapTrigger"], ["childMenu", "matMenu"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["mat-menu-item", "", "color", "primary", 1, "sol-floating-menu-item", 3, "matMenuTriggerFor", "disabled", "title"], [1, "sol-floating-menu-item-content"], [1, "sol-floating-menu-left-content"], [3, "iconName", "spritePath", "wrapperClass", 4, "ngIf"], [1, "label-text"], [1, "sol-floating-menu-right-content"], ["class", "menu-divider", 4, "ngIf"], [3, "items", "variant"], ["menu", ""], [3, "iconName", "spritePath", "wrapperClass"], [1, "menu-divider"], ["mat-menu-item", "", "class", "sol-floating-menu-item", 3, "disabled", "title", "click", 4, "ngIf"], ["class", "sol-menu-item-button", 3, "title", 4, "ngIf"], ["mat-menu-item", "", 1, "sol-floating-menu-item", 3, "disabled", "title", "click"], [1, "sol-floating-menu-leaf-node", "sol-floating-menu-right-content"], [1, "sol-menu-item-button", 3, "title"], ["LeadingIcon", ""], ["variant", "primary", 3, "iconPositionedFront", "click"]],
      template: function MenuItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "mat-menu", 0, 1);
          i0.ɵɵtemplate(2, MenuItemComponent_span_2_Template, 3, 2, "span", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.menuClassname);
          i0.ɵɵproperty("overlapTrigger", false);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.items);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i2.MatMenu, i2.MatMenuItem, i2.MatMenuTrigger, i3.ButtonComponent, i4.SvgSpriteIconComponent, MenuItemComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuItemComponent, [{
    type: Component,
    args: [{
      selector: 'sol-menu-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      exportAs: 'floatingMenuItem',
      template: "<mat-menu #childMenu=\"matMenu\" [overlapTrigger]=\"false\" [class]=\"menuClassname\">\n  <span *ngFor=\"let child of items\">\n    <!-- Handle branch node menu items -->\n    <span *ngIf=\"child.children && child.children.length > 0\">\n      <button\n        mat-menu-item\n        color=\"primary\"\n        [matMenuTriggerFor]=\"menu.childMenu\"\n        [disabled]=\"child.disabled\"\n        title=\"{{ child.tooltipText }}\"\n        class=\"sol-floating-menu-item\"\n      >\n        <div class=\"sol-floating-menu-item-content\">\n          <span class=\"sol-floating-menu-left-content\">\n            <sol-svg-sprite-icon\n              *ngIf=\"child.svgIconName\"\n              [iconName]=\"child.svgIconName\"\n              [spritePath]=\"spriteIconPath\"\n              [wrapperClass]=\"'sol-menu-icon'\"\n            ></sol-svg-sprite-icon>\n            <span class=\"label-text\">{{ child.label }}</span>\n          </span>\n          <span class=\"sol-floating-menu-right-content\">{{ child.description }}</span>\n        </div>\n      </button>\n      <hr class=\"menu-divider\" *ngIf=\"child.showDivider\" />\n      <sol-menu-item #menu [items]=\"child.children\" [variant]=\"variant\"></sol-menu-item>\n    </span>\n    <!-- Handle leaf node menu items -->\n    <span *ngIf=\"!child.children || child.children.length === 0\">\n      <button\n        mat-menu-item\n        [disabled]=\"child.disabled\"\n        title=\"{{ child.tooltipText }}\"\n        (click)=\"handleMenuItemClick(child)\"\n        class=\"sol-floating-menu-item\"\n        *ngIf=\"child.type !== 'button'\"\n      >\n        <div class=\"sol-floating-menu-item-content\">\n          <span class=\"sol-floating-menu-left-content\">\n            <sol-svg-sprite-icon\n              *ngIf=\"child.svgIconName\"\n              [iconName]=\"child.svgIconName\"\n              [spritePath]=\"spriteIconPath\"\n              [wrapperClass]=\"'sol-menu-icon'\"\n            ></sol-svg-sprite-icon>\n            <span class=\"label-text\">{{ child.label }}</span>\n          </span>\n          <span class=\"sol-floating-menu-leaf-node sol-floating-menu-right-content\">{{ child.description }}</span>\n        </div>\n      </button>\n      <div *ngIf=\"child.type === 'button'\" class=\"sol-menu-item-button\" title=\"{{ child.tooltipText }}\">\n        <ng-template #LeadingIcon>\n          <sol-svg-sprite-icon\n            *ngIf=\"child.svgIconName\"\n            [iconName]=\"child.svgIconName\"\n            [spritePath]=\"spriteIconPath\"\n            [wrapperClass]=\"'sol-menu-icon'\"\n          ></sol-svg-sprite-icon>\n        </ng-template>\n        <sol-button variant=\"primary\" [iconPositionedFront]=\"LeadingIcon\" (click)=\"handleMenuItemClick(child)\">{{ child.label }}</sol-button>\n      </div>\n      <hr class=\"menu-divider\" *ngIf=\"child.showDivider\" />\n    </span>\n  </span>\n</mat-menu>\n"
    }]
  }], null, {
    items: [{
      type: Input
    }],
    childMenu: [{
      type: ViewChild,
      args: [MatMenu, {
        static: true
      }]
    }],
    variant: [{
      type: Input
    }],
    spriteIconPath: [{
      type: Input
    }]
  });
})();
class FloatingMenuComponent {
  constructor() {
    this.menuItems = [];
    this.variant = 'wide';
    this.spriteIconPath = '';
    this.menuClass = '';
  }
  get menuClassname() {
    return `sol-floating-menu ${this.variant}  ${this.menuClass}`;
  }
  handleMenuItemClick(item) {
    if (item.callbackFn) {
      item.callbackFn(item);
    }
  }
  static {
    this.ɵfac = function FloatingMenuComponent_Factory(t) {
      return new (t || FloatingMenuComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FloatingMenuComponent,
      selectors: [["sol-floating-menu"]],
      viewQuery: function FloatingMenuComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatMenu, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menu = _t.first);
        }
      },
      inputs: {
        menuItems: "menuItems",
        variant: "variant",
        spriteIconPath: "spriteIconPath",
        menuClass: "menuClass"
      },
      exportAs: ["floatingMenu"],
      decls: 4,
      vars: 3,
      consts: [["menu", "matMenu"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "keydown.tab", 4, "ngIf"], ["mat-menu-item", "", 1, "sol-floating-menu-item", 3, "matMenuTriggerFor", "disabled", "title"], ["menuTrigger", "matMenuTrigger"], [1, "sol-floating-menu-item-content"], [1, "sol-floating-menu-left-content"], [3, "iconName", "spritePath", "wrapperClass", 4, "ngIf"], [1, "label-text"], ["class", "sol-floating-menu-right-content", 4, "ngIf"], ["class", "menu-divider", 4, "ngIf"], [3, "items", "variant", "spriteIconPath"], ["menu", "floatingMenuItem"], [3, "iconName", "spritePath", "wrapperClass"], [1, "sol-floating-menu-right-content"], [1, "menu-divider"], [3, "keydown.tab"], ["mat-menu-item", "", "class", "sol-floating-menu-item", 3, "disabled", "title", "click", 4, "ngIf"], ["class", "sol-menu-item-button", 3, "title", 4, "ngIf"], ["mat-menu-item", "", 1, "sol-floating-menu-item", 3, "disabled", "title", "click"], ["className", "sol-menu-icon", 3, "icon", 4, "ngIf"], ["class", "sol-floating-menu-leaf-node sol-floating-menu-right-content", 4, "ngIf"], ["className", "sol-menu-icon", 3, "icon"], [1, "sol-floating-menu-leaf-node", "sol-floating-menu-right-content"], [1, "sol-menu-item-button", 3, "title"], ["LeadingIcon", ""], ["variant", "primary", 3, "iconPositionedFront", "click"]],
      template: function FloatingMenuComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "mat-menu", null, 0)(2, "div");
          i0.ɵɵtemplate(3, FloatingMenuComponent_span_3_Template, 3, 2, "span", 1);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.menuClassname);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.menuItems);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i2.MatMenu, i2.MatMenuItem, i2.MatMenuTrigger, i3.ButtonComponent, i4$1.IconComponent, i4.SvgSpriteIconComponent, MenuItemComponent],
      styles: [".sol-floating-menu.mat-mdc-menu-panel{width:20.875rem;max-width:unset;min-height:unset;border-style:solid;border-width:var(--border-size1);border-color:var(--color-interface-border2);box-shadow:0 .063rem .125rem var(--color-shadow-level1);padding:.5rem}.sol-floating-menu.mat-mdc-menu-panel.narrow{width:12.25rem}.sol-floating-menu.mat-mdc-menu-panel .mat-mdc-menu-content:not(:empty){padding:0}.sol-floating-menu.mat-mdc-menu-panel .sol-menu-item-button{padding-top:.5rem}.sol-floating-menu.mat-mdc-menu-panel .sol-menu-item-button button{width:19.75rem}.sol-floating-menu.mat-mdc-menu-panel .sol-menu-item-button .sol-menu-icon{fill:var(--color-button-basic-normal);width:1.25rem;height:1.25rem;vertical-align:middle}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item{display:block;width:100%;height:2.25rem;min-height:2.25rem;padding:0 1.25rem 0 .5rem;color:var(--color-interface-blue650)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-item-content{display:flex;justify-content:space-between;align-items:center}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-left-content .sol-menu-icon{padding-right:.5rem;width:1.25rem;height:1.25rem;vertical-align:middle;fill:var(--color-globalstate-inactive-text)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-left-content{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-left-content span{vertical-align:middle;font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);text-transform:var(--typography-opensans-body-body3-text-case);font-stretch:var(--typography-opensans-body-body3-font-stretch)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-right-content{display:flex;font-size:var(--typography-opensans-body-body4-font-size);padding-left:.5rem;color:var(--color-interface-text700);white-space:nowrap}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-leaf-node{justify-content:flex-end}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .mat-mdc-menu-submenu-icon{right:.5rem;color:var(--color-globalstate-inactive-text)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item:hover{background:var(--color-globalstate-hover-background)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item:disabled{background:var(--color-globalstate-disabled-background);color:var(--color-globalstate-disabled-content)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item:disabled .sol-menu-icon{fill:var(--color-globalstate-disabled-content)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item:disabled .sol-floating-menu-right-content{color:var(--color-globalstate-disabled-content)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item:active{background:var(--color-interface-background50)}.sol-floating-menu.mat-mdc-menu-panel .menu-divider{border-style:solid;border-width:var(--border-size1);border-color:var(--color-interface-border1);margin:.5rem}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FloatingMenuComponent, [{
    type: Component,
    args: [{
      selector: 'sol-floating-menu',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      exportAs: 'floatingMenu',
      template: "<mat-menu #menu=\"matMenu\" [class]=\"menuClassname\">\n  <div>\n    <span *ngFor=\"let item of menuItems\">\n      <!-- Handle branch node buttons here -->\n      <span *ngIf=\"item.children && item.children.length > 0\">\n        <button\n          mat-menu-item\n          [matMenuTriggerFor]=\"menu.childMenu\"\n          [disabled]=\"item.disabled\"\n          #menuTrigger=\"matMenuTrigger\"\n          title=\"{{ item.tooltipText }}\"\n          class=\"sol-floating-menu-item\"\n        >\n          <div class=\"sol-floating-menu-item-content\">\n            <span class=\"sol-floating-menu-left-content\">\n              <sol-svg-sprite-icon\n                *ngIf=\"item.svgIconName\"\n                [iconName]=\"item.svgIconName\"\n                [spritePath]=\"spriteIconPath\"\n                [wrapperClass]=\"'sol-menu-icon'\"\n              ></sol-svg-sprite-icon>\n              <span class=\"label-text\">{{ item.label }}</span>\n            </span>\n\n            <span class=\"sol-floating-menu-right-content\" *ngIf=\"item.description\">{{ item.description }}</span>\n          </div>\n        </button>\n        <hr class=\"menu-divider\" *ngIf=\"item.showDivider\" />\n        <sol-menu-item #menu=\"floatingMenuItem\" [items]=\"item.children\" [variant]=\"variant\" [spriteIconPath]=\"spriteIconPath\"></sol-menu-item>\n      </span>\n      <!-- Leaf node buttons here -->\n      <span *ngIf=\"!item.children || item.children.length === 0\" (keydown.tab)=\"$event.stopPropagation()\">\n        <button\n          mat-menu-item\n          [disabled]=\"item.disabled\"\n          title=\"{{ item.tooltipText }}\"\n          (click)=\"handleMenuItemClick(item)\"\n          class=\"sol-floating-menu-item\"\n          *ngIf=\"item.type !== 'button'\"\n        >\n          <div class=\"sol-floating-menu-item-content\">\n            <span class=\"sol-floating-menu-left-content\">\n              <sol-icon *ngIf=\"item.icon\" [icon]=\"item.icon\" className=\"sol-menu-icon\"></sol-icon>\n              <sol-svg-sprite-icon\n                *ngIf=\"item.svgIconName && !item.icon\"\n                [iconName]=\"item.svgIconName\"\n                [spritePath]=\"spriteIconPath\"\n                [wrapperClass]=\"'sol-menu-icon'\"\n              ></sol-svg-sprite-icon>\n              <span>{{ item.label }}</span>\n            </span>\n            <span class=\"sol-floating-menu-leaf-node sol-floating-menu-right-content\" *ngIf=\"item.description\">{{ item.description }}</span>\n          </div>\n        </button>\n        <div *ngIf=\"item.type === 'button'\" class=\"sol-menu-item-button\" title=\"{{ item.tooltipText }}\">\n          <ng-template #LeadingIcon>\n            <sol-svg-sprite-icon\n              *ngIf=\"item.svgIconName\"\n              [iconName]=\"item.svgIconName\"\n              [spritePath]=\"spriteIconPath\"\n              [wrapperClass]=\"'sol-menu-icon'\"\n            ></sol-svg-sprite-icon>\n          </ng-template>\n          <sol-button variant=\"primary\" [iconPositionedFront]=\"LeadingIcon\" (click)=\"handleMenuItemClick(item)\">{{ item.label }}</sol-button>\n        </div>\n        <hr class=\"menu-divider\" *ngIf=\"item.showDivider\" />\n      </span>\n    </span>\n  </div>\n</mat-menu>\n",
      styles: [".sol-floating-menu.mat-mdc-menu-panel{width:20.875rem;max-width:unset;min-height:unset;border-style:solid;border-width:var(--border-size1);border-color:var(--color-interface-border2);box-shadow:0 .063rem .125rem var(--color-shadow-level1);padding:.5rem}.sol-floating-menu.mat-mdc-menu-panel.narrow{width:12.25rem}.sol-floating-menu.mat-mdc-menu-panel .mat-mdc-menu-content:not(:empty){padding:0}.sol-floating-menu.mat-mdc-menu-panel .sol-menu-item-button{padding-top:.5rem}.sol-floating-menu.mat-mdc-menu-panel .sol-menu-item-button button{width:19.75rem}.sol-floating-menu.mat-mdc-menu-panel .sol-menu-item-button .sol-menu-icon{fill:var(--color-button-basic-normal);width:1.25rem;height:1.25rem;vertical-align:middle}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item{display:block;width:100%;height:2.25rem;min-height:2.25rem;padding:0 1.25rem 0 .5rem;color:var(--color-interface-blue650)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-item-content{display:flex;justify-content:space-between;align-items:center}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-left-content .sol-menu-icon{padding-right:.5rem;width:1.25rem;height:1.25rem;vertical-align:middle;fill:var(--color-globalstate-inactive-text)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-left-content{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-left-content span{vertical-align:middle;font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);text-transform:var(--typography-opensans-body-body3-text-case);font-stretch:var(--typography-opensans-body-body3-font-stretch)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-right-content{display:flex;font-size:var(--typography-opensans-body-body4-font-size);padding-left:.5rem;color:var(--color-interface-text700);white-space:nowrap}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .sol-floating-menu-leaf-node{justify-content:flex-end}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item .mat-mdc-menu-submenu-icon{right:.5rem;color:var(--color-globalstate-inactive-text)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item:hover{background:var(--color-globalstate-hover-background)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item:disabled{background:var(--color-globalstate-disabled-background);color:var(--color-globalstate-disabled-content)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item:disabled .sol-menu-icon{fill:var(--color-globalstate-disabled-content)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item:disabled .sol-floating-menu-right-content{color:var(--color-globalstate-disabled-content)}.sol-floating-menu.mat-mdc-menu-panel .sol-floating-menu-item:active{background:var(--color-interface-background50)}.sol-floating-menu.mat-mdc-menu-panel .menu-divider{border-style:solid;border-width:var(--border-size1);border-color:var(--color-interface-border1);margin:.5rem}\n"]
    }]
  }], null, {
    menuItems: [{
      type: Input
    }],
    menu: [{
      type: ViewChild,
      args: [MatMenu, {
        static: true
      }]
    }],
    variant: [{
      type: Input
    }],
    spriteIconPath: [{
      type: Input
    }],
    menuClass: [{
      type: Input
    }]
  });
})();
class FloatingMenuModule {
  static {
    this.ɵfac = function FloatingMenuModule_Factory(t) {
      return new (t || FloatingMenuModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FloatingMenuModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, MatMenuModule, ButtonModule, IconModule, SvgSpriteIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FloatingMenuModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, MatMenuModule, ButtonModule, IconModule, SvgSpriteIconModule],
      declarations: [FloatingMenuComponent, MenuItemComponent],
      exports: [FloatingMenuComponent, MenuItemComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of floating-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FloatingMenuComponent, FloatingMenuModule, MenuItemComponent };
